import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { CommonService } from '../common.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private commonService: CommonService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (!this.commonService.isAuthenticated()) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
